import { Box, CircularProgress, Typography } from "@material-ui/core";

import { useI18nContext } from "@hopper-b2b/i18n";
import { ActionButton } from "@hopper-b2b/ui";

import { PriceBreakdownStep } from "../PriceBreakdownStep";

import "./styles.scss";

export interface ICheckoutBreakdownProps {
  isSubmitting: boolean;
  onSubmit: () => void;
}

const defaultProps: Partial<ICheckoutBreakdownProps> = {};

const CheckoutBreakdown = (props: ICheckoutBreakdownProps): JSX.Element => {
  const { isSubmitting, onSubmit } = props;
  const { t } = useI18nContext();

  return (
    <Box className="checkout-breakdown-container hopper-card">
      <Typography className="title">
        {t("exchangeable.priceBreakdown.title")}
      </Typography>
      <PriceBreakdownStep enablePricingToggle />
      <ActionButton
        defaultStyle="h4r-primary"
        className="submit-exchange-req-btn"
        disabled={isSubmitting}
        message={
          isSubmitting ? (
            <CircularProgress className="processing-exchange-req-spinner" />
          ) : (
            t("exchangeable.submit.submitReq")
          )
        }
        onClick={onSubmit}
      />
    </Box>
  );
};

CheckoutBreakdown.defaultProps = defaultProps;

export default CheckoutBreakdown;
